import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '../../actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { RequestsService } from '@app-services/requests/requests.service';

@Injectable()
export class PermissionRequestEffects {
  constructor(
    private actions$: Actions,
    private requestService: RequestsService
  ) {}

  loadRequestList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getRequestPermission),
      mergeMap((action) =>
        this.requestService.getRequestPermissionList(action.params).pipe(
          map((data) =>
            actions.getRequestPermissionSuccess({
              requestlist: data.request,
              count: data.count,
            })
          ),
          catchError((err) =>
            of(actions.getRequestPermissionError({ payload: err }))
          )
        )
      )
    )
  );
}
